import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComparisonComponent } from './dashboard-comparison/dashboard-comparison.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/price_estimator',
    pathMatch: 'full',
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
   {
    path: 'revenue',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/revenue.json' },
  },
   {
    path: 'screen-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/screen-1.json' },
  },
  {
    path: 'all-charts',
    redirectTo: 'all-chart-1',
    pathMatch: 'full',
  },
  {
    path: 'all-chart-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-1.json' },
  },
  {
    path: 'customer_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_view.json' },
  },
  {
    path: 'config_criteria',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/config_criteria.json' },
  },
  {
    path: 'mine_weighted',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/mine_weighted.json' },
  },
   {
    path: 'price_estimator',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/price_estimator.json' },
  },
   {
    path: 'customer_view_2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_view_2.json' },
  },
   {
    path: 'table',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/table.json' },
  },
  {
    path: 'stack-bar',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/stack-bar.json' },
  },
  {
    path: 'customer_overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_overview.json' },
  },
  {
    path: 'price_analysis_engine_level',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/price_analysis_engine_level.json' },
  },
  {

    path: 'price_estimator_second',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/price_estimator_second.json' },
  },
{
    path: 'price_planner',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/price_planner.json' },
  },
  {
    path: 'comparison_bar_chart',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/comparison_bar_chart.json' },
  },
  {
    path: 'equipment_uptime',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/equipment_uptime.json' },
  },

  


  {
    path: 'all-chart-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-2.json' },
  },
  {
    path: 'all-chart-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-3.json' },
  },
  {
    path: 'test',
    component: DashboardComparisonComponent,
    canActivate: [AuthGuard],
  },

   {
    path: 'all-charts-dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-charts-theme.json' },
  },
  
  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
   {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
   {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'dvm-charts_dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-dark-theme.json' },
  },

  {
    path: 'dvm-charts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-light-theme.json' },
  },

  {
    path: 'chat',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config.json' },
  },
  {
    path: 'login',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/login_page.json' },
  },
   {
    path: 'oem_positioning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/oem_positioning.json' },
  },
  {
    path: 'confer',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/confer.json' },
  },
  {
    path: 'configuration',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/configuration.json' },
  },
   {
    path: 'scatter',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/scatter.json' },
  },
  {
    path: 'customer_overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_overview.json' },
  },
   

  {
    path: '**',
    redirectTo: '/price_estimator',
  },
];
